import { formatTimeAgo } from "@vueuse/core";

export default function timeAgoLabel(date: Date){
    return formatTimeAgo(new Date(date))
      .replace(" minutes", "m")
      .replace(" minute", "m")
      .replace(" hours", "h")
      .replace(" hour", "h")
      .replace(" days", "d")
      .replace(" weeks", "w")
      .replace(" months", "mo")
      .replace(" years", "y")
}